import {AuthGuard} from '../../shared/guards/AuthGuard';
import {AnalysisHiringPresentation} from './components';
import {Sidebar} from '../../shared/components';

export const AnalysisHiringPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <AnalysisHiringPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};